import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={33} height={42} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="m28.54.5.213.952C22.417 4.431 16.587 8.978 13.42 13.77c1.47-.785 3.2-1.228 5.075-1.228 6.918 0 13.244 5.786 13.244 13.784 0 7.863-5.705 15.026-15.242 15.026-4.87 0-8.883-1.663-11.677-4.625C2.031 33.767.5 29.559.5 24.544.5 15.614 6.215 5.289 15.295.557L15.403.5H28.54ZM16.012 20.94c-1.583 0-2.95.551-3.92 1.52-.968.97-1.574 2.39-1.574 4.19 0 1.83.607 3.263 1.576 4.238.97.975 2.335 1.526 3.918 1.526 1.554 0 2.921-.55 3.9-1.527.975-.976 1.594-2.41 1.594-4.237 0-1.797-.618-3.218-1.594-4.188-.978-.972-2.346-1.522-3.9-1.522Z"
        />
    </Svg>
);
export { SvgComponent as SixIcon };
